import { module } from 'modujs';
import { html } from '../utils/environment';
import { lazyLoadImage } from '../utils/image';
import LocomotiveScroll from 'locomotive-scroll';

export default class Scroll extends module {

    static get settings() {
        return {
            CLASS_SCROLL_TOP: 'is-scroll-top',
            CLASS_SCROLL_UP: 'is-scrolling-up',
            CLASS_SCROLL_DOWN: 'is-scrolling-down',
        }
    }

    constructor(m) {
        super(m);

        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual'

            window.scrollTo(0,0)
        }
    }

    init() {
        // Create scroll instance
        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            scrollCallback: this.onScroll.bind(this),
            // scrollCallback: this.onScrollBind,
            // lenisOptions: {
            //     duration: 1,
            //     smooth: false
            // }
        })

        this.scrollDirection = 0
        this.bindScrollTo()
        html.classList.add(Scroll.settings.CLASS_SCROLL_TOP)
    }

    /**
    * On scroll
    *
    * @param {event}
    */
    onScroll(e) {

        // Set scroll top
        const scrollTop = e.scroll < 10
        html.classList.toggle(Scroll.settings.CLASS_SCROLL_TOP, scrollTop)

        // Update direction
        const direction = e.direction
        if(direction !== this.scrollDirection) {
            const scrollDown = direction > 0
            html.classList.toggle(Scroll.settings.CLASS_SCROLL_DOWN, scrollDown)
            html.classList.toggle(Scroll.settings.CLASS_SCROLL_UP, !scrollDown)
            this.scrollDirection = direction
        }

        if(direction !== 0) {
            this.call('setSticky', !scrollTop && direction < 0, 'Header')
        }
    }

    bindScrollTo() {
        let target, offset
        this.scrollTargetsEvents = []
        this.$scrollTargets = document.querySelectorAll('a[href^="#"]')

        this.$scrollTargets.forEach((button, i) => {
            this.scrollTargetsEvents[i] = e => {
                e.preventDefault()
                target = `#${button.getAttribute('href').split('#')[1]}`
                this.scrollTo({ target })
            }

            button.addEventListener('click', this.scrollTargetsEvents[i])
        })

        // Initial scroll
        const hash = document.URL.split('#')
        if(hash.length > 1) {
            setTimeout(() => {
                this.scrollTo({ target: `#${hash[1]}`, immediate: true })
            }, 10)
        }
    }

    unbindScrollTo() {

        if(this.$scrollTargets.length > 0) {
            this.$scrollTargets.forEach((target, i) => {
                target.removeEventListener('click', this.scrollTargetsEvents[i])
            })
        }
    }

    /**
    * Update scroll Elements
    *
    * @param {object}
    */
    removeScrollElements($oldContainer) {
        this.scroll?.removeScrollElements($oldContainer)
    }

    addScrollElements($newContainer) {
        this.scroll?.addScrollElements($newContainer)
    }

    /**
    * Scroll to
    *
    * @param {object}
    */
    scrollTo(params) {
        const { target, ...options } = params

        // Mobile nav offset
        if (!options.offset && window.innerWidth < 1000) {
            options.offset = -100
        }

        this.scroll?.scrollTo(target, options)
    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    lazyLoad(args) {
        const { target } = args;
        lazyLoadImage(target);
    }

    toggleVideo(e) {
        if(e.way === 'enter') {
            e.target?.play()
        } else {
            e.target?.pause()
        }
    }

    destroy() {
        this.unbindScrollTo()
        this.scroll?.destroy()
    }
}
